import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { lengthValidation250, required } from '../Forms/utils';
import { formatRecipients } from './utils';

import { secondaryColor } from '../../theme';
import { REACT_SELECT_INPUT, STYLED_TEXT } from '../Forms/fieldTypes';

const RejectVisitor = ({
  residents,
  staff,
  building,
  selectedCameraId,
  form,
  onSubmit,
  onModalClose,
  isFrontDesk,
}) => {
  const { t } = useTransl();
  const residentsAndStaff = [].concat(residents, staff);
  const formData = [
    {
      keyName: 'comment',
      label: t('title.visitorNameAndDetails'),
      fieldType: STYLED_TEXT,
      multiline: true,
      validate: [required, lengthValidation250],
    },
    {
      keyName: 'recipient',
      label: t('title.host'),
      fieldType: REACT_SELECT_INPUT,
      options: formatRecipients(residentsAndStaff, true, isFrontDesk),
      placeholder: isFrontDesk
        ? t('callCenter.selectHost')
        : t('delivery.filterBy'),
      validate: [required],
    },
  ];

  const customSubmitStyle = {
    backgroundColor: secondaryColor,
  };

  if (isFrontDesk) {
    customSubmitStyle.width = 'fit-content';
    customSubmitStyle.marginLeft = 'auto';
  }

  return (
    <GenericFormContainer
      form={form}
      formData={formData}
      onSubmit={onSubmit}
      title={t('callCenter.rejectVisitor')}
      submitText={t('callCenter.rejectVisitor')}
      customSubmitStyle={customSubmitStyle}
      isUpdate={false}
      canBeUpdated={false}
      backButton={false}
      isFullWidthForm
      isFullWidthSubmit
      building={building}
      selectedCameraId={selectedCameraId}
      onModalClose={onModalClose}
    />
  );
};

RejectVisitor.defaultProps = {
  onSubmit: () => {},
  onModalClose: () => {},
  building: {},
  selectedCameraId: null,
};

RejectVisitor.propTypes = {
  residents: PropTypes.instanceOf(Array).isRequired,
  staff: PropTypes.instanceOf(Array).isRequired,
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func,
  building: PropTypes.instanceOf(Object),
  selectedCameraId: PropTypes.number,
  onModalClose: PropTypes.func,
  isFrontDesk: PropTypes.bool,
};

export default RejectVisitor;
